<template>
    <el-dialog :title="$t('editEmployee')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog"
               top="5vh">
        <div class="content">
            <el-form :model="formData"
                     size="mini"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <el-form-item :label="$t('employeeName')" prop="username">
                    <el-input v-model="formData.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('serialNumber')" prop="number">
                    <el-input v-model="formData.number" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('email')" prop="email">
                    <el-input v-model="formData.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('phoneNum')" class="form-item-group" required>
                    <el-row>
                        <el-col :span="5">
                            <vue-country-intl schema="popover" :searchInputPlaceholder="$t('countryCodeSearch')" class="country-code" v-model="countryCode">
                                <a href="javascript:void(0)" class="area-code" slot="reference">
                                    <i>+</i>
                                    <span>{{ countryCode }}</span>
                                    <i class="el-icon-caret-bottom"></i>
                                </a>
                            </vue-country-intl>
                        </el-col>
                        <el-col :span="1" style="height: 1px;"></el-col>
                        <el-col :span="18">
                            <el-form-item prop="mobile">
                                <el-input v-model.trim="formData.mobile"
                                          autocomplete="off"
                                          :placeholder="$t('inputPhoneHint')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <!--<el-form-item :label="$t('password')" prop="password">-->
                <!--    <el-input v-model="formData.password" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item :label="$t('role')" prop="roleIds">
                    <el-select
                        v-model="formData.roleIds"
                        multiple
                        collapse-tags
                        :placeholder="$t('pleaseSelectHint')">
                        <el-option
                            v-for="item in roleOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('whetherEnable')"
                              prop="enabled">
                    <el-switch
                        v-model="formData.enabled"
                        active-color="#13ce66"
                        inactive-color="#dcdfe6">
                    </el-switch>
                </el-form-item>
                <el-form-item :label="$t('headPortrait')"
                              prop="avatar">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequest"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.avatar" class="avatar" v-if="formData.avatar">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveImage" v-if="formData.avatar"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {updateEmployee, queryEmployeeDetails, searchRoleList} from "@/api/modules/user";
import {uploadImage} from "@/api/modules/api";

export default {
    name: "Add",
    // 组件
    components: {},
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            roleOptions: [],
            formData: {
                username: '',
                number: '',
                email: '',
                mobile: '',
                // password: '',
                roleIds: [],
                enabled: true,
                remark: '',
                avatar: '',
            },
            rules: {
                username: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                email: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                mobile: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                password: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                roleIds: [{ type: 'array', required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                enabled: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
            },
            countryCode: '39',
            disabled: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    // 方法集合
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
            if (this.roleOptions.length === 0) {
                this.getRoleOptions()
            }
        },
        
        // 获取详情
        getDetails () {
            queryEmployeeDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    // 手机号
                    let mobileStr = resData.mobile || ''
                    let index = mobileStr.indexOf('-')
                    let mobile = ''
                    if (index !== -1) {
                        this.countryCode = mobileStr.substring(0, index)
                        mobile = mobileStr.substring(index+1)
                    } else {
                        this.countryCode = ''
                        mobile = mobileStr
                    }
                    // 角色
                    let roleIds = resData.roles.map(item => {
                        return item.id
                    })
                    this.formData = {
                        username: resData.username,
                        number: resData.number,
                        email: resData.email,
                        mobile,
                        // password: resData.password,
                        roleIds,
                        enabled: resData.enabled,
                        remark: '',
                        avatar: resData.avatar
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        
        // 获取角色选项
        getRoleOptions () {
            searchRoleList().then(res => {
                if (Number(res.code) === 20000) {
                    this.roleOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        /******** 图片 ********/
        httpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.avatar = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                this.$message.error(err);
            })
        },
        // 清除图片
        handleRemoveImage () {
            this.formData.avatar = ''
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            let mobile = this.formData.mobile.trim()
            if (this.countryCode) {
                mobile = `${this.countryCode}-${mobile}`
            }
            const params = {
                id: this.parentId,
                username: this.formData.username.trim(),
                number: this.formData.number.trim(),
                email: this.formData.email.trim(),
                mobile: mobile,
                // password: this.formData.password.trim(),
                roleIds: this.formData.roleIds,
                enabled: this.formData.enabled,
                // remark: this.formData.remark.trim(),
                avatar: this.formData.avatar,
            }
            this.disabled = true;
            updateEmployee(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'success'
                    })
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
    
    },
    // 组件被激活
    activated() {
    
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/css/form-dialog.scss';
::v-deep .el-form{
    .form-item-group{
        .el-form-item__content{
            .el-row{
                height: 32px;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                .el-input{
                    .el-input__inner{
                        border: none;
                    }
                }
                .country-code{
                    width: 100%;
                    height: 28px;
                    .area-code{
                        display: flex;
                        width: 100%;
                        height: 100%;
                        justify-content: center;
                        align-items: center;
                        color: #272727;
                    }
                }
            }
        }
    }
}
</style>
